import type { JSX } from 'react'

import { CoreComposerEditorSurface } from '~publish/components/Composer/components/EditorSurface'
import type { EditorSurfaceProps } from '~publish/components/Composer/components/EditorSurface'
import type {
  BufferEditor,
  BufferValue,
} from '~publish/legacy/editor/BufferEditor/types.plate'

import styles from '~publish/legacy/composer/composer/editor/ComposerEditor/ComposerEditor.module.css'

export type ComposerTextAreaProps = Readonly<{
  editor: BufferEditor
  editableProps: EditorSurfaceProps<BufferValue>['editableProps']
  onChange: EditorSurfaceProps<BufferValue>['onChange']
  expanded: boolean
  hasLinkAttachment: boolean
  imageFirst: boolean
}>

export function ComposerTextArea({
  editor,
  editableProps,
  onChange,
  expanded,
  hasLinkAttachment,
  imageFirst,
}: ComposerTextAreaProps): JSX.Element {
  return (
    <div className={styles.composerEditorWrapper}>
      <div
        className={styles.composerTextArea}
        data-expanded={expanded}
        data-has-link-attachment={hasLinkAttachment}
        data-image-first={imageFirst}
      >
        <CoreComposerEditorSurface
          editableProps={editableProps}
          editor={editor}
          onChange={onChange}
        />
      </div>
    </div>
  )
}
